
import { renderRouter } from './router';

const mountPoint = document.getElementById('root');

(async () => {
	if (mountPoint) {
		renderRouter(mountPoint);
	} else {
		throw new Error("Root element not found");
	}
})();